<div class="tooltip-container style-{{style}} size-{{size}} position-{{position}}" [style.top]="top + 'px'"
  [style.left]="left + 'px'" [style.right]="right + 'px'" [class.bottom]="bottom" *ngIf="text || htmlContent">
  <div class="tooltip" [@tooltip]>
    <img *ngIf="imageUrl" [src]="imageUrl" alt="">
    <h3 *ngIf="title">{{title}}</h3>
    <div *ngIf="!htmlContent">{{text}}<span *ngIf="keyboardShortcut" class="shortcut"><span
          *ngIf="keyboardShortcutMeta">{{metaKey}}+</span>{{keyboardShortcut}}</span></div>
    <div *ngIf="htmlContent" [innerHTML]="htmlContent"></div>
  </div>
</div>
